module.exports = __webpack_public_path__ + "img/IT0000102341108.d55597ab.png";